import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME, APP_TAGLINE, ROUTES, COLORS } from '../../constants';

export default function Header({ showBackButton = false, backButtonText = 'Back to Home' }) {
  return (
    <div className="relative bg-gradient-to-r from-[#79974e] via-[#6d8544] to-[#79974e] shadow-2xl">
      <div className="absolute inset-0 bg-black opacity-10"></div>
      <div className="relative flex items-center p-6 pb-4 justify-between">
        {/* Logo and Company Name - Left Side */}
        <div className="flex items-center gap-4 pl-6">
          <div className="relative group">
            <img 
              src="/images/logo/lokvir_logo.png" 
              alt={`${APP_NAME} Logo`} 
              className="h-16 w-auto drop-shadow-lg transform group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute -inset-2 bg-white/10 rounded-full -z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </div>
          <div className="group">
            <Link to={ROUTES.HOME}>
              <h1 
                className="text-2xl md:text-3xl font-black leading-tight tracking-wider drop-shadow-lg group-hover:scale-105 transition-transform duration-300" 
                style={{
                  color: 'rgb(247, 235, 207)', 
                  fontFamily: 'Plus Jakarta Sans, serif', 
                  letterSpacing: '0.05em'
                }}
              >
                {APP_NAME}
              </h1>
              <p className="text-green-100 text-sm font-medium tracking-widest">
                {APP_TAGLINE}
              </p>
            </Link>
          </div>
        </div>

        {/* Right Side Button */}
        <div className="pr-6">
          {showBackButton ? (
            <Link 
              to={ROUTES.HOME}
              className="flex items-center gap-2 bg-gradient-to-r from-[#9be830] to-[#8bd020] text-black px-6 py-3 rounded-xl font-semibold text-base hover:shadow-lg transform hover:scale-[1.05] transition-all shadow-lg"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
                <path d="M218.83,103.77l-80-75.48a1.14,1.14,0,0,1-.11-.11,16,16,0,0,0-21.53,0l-.11.11L37.17,103.77A16,16,0,0,0,32,115.55V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V160h32v48a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V115.55A16,16,0,0,0,218.83,103.77ZM208,208H160V160a16,16,0,0,0-16-16H112a16,16,0,0,0-16,16v48H48V115.55l.11-.10L128,40l79.9,75.43.11.10Z"/>
              </svg>
              {backButtonText}
            </Link>
          ) : (
            <Link 
              to={ROUTES.CONTACT}
              className="flex items-center gap-2 bg-gradient-to-r from-[#9be830] to-[#8bd020] text-black px-6 py-3 rounded-xl font-semibold text-base hover:shadow-xl transform hover:scale-105 transition-all duration-300 shadow-lg"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
                <path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"/>
              </svg>
              Contact Us
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

